import sortBy from 'lodash/sortBy';

type ContentItem = {
  id: number;
  sort?: string | null;
  integratedSort?: string | null;
};

export function getContentNumber(
  id: number,
  isIntegrated: boolean,
  content?: ContentItem[]
) {
  if (!content) return 0;

  const sortedContent = sortBy(
    content,
    isIntegrated ? 'integratedSort' : 'sort'
  );
  const index = sortedContent.findIndex(item => item.id === id);
  return index > -1 ? index + 1 : undefined;
}
